var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150.41 45.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#037068;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.43,21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.39,45.72a19.1,19.1,0,1,1,19.1-19.1A19.12,19.12,0,0,1,20.39,45.72Zm0-35A15.87,15.87,0,1,0,36.26,26.62,15.89,15.89,0,0,0,20.39,10.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.75,
    y: 12.53,
    width: 3.28,
    height: 1.39,
    rx: 0.29,
    transform: "translate(33.61 -7.17) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.75,
    y: 39.32,
    width: 3.28,
    height: 1.39,
    rx: 0.29,
    transform: "translate(60.41 19.63) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.15,
    y: 25.92,
    width: 3.28,
    height: 1.39,
    rx: 0.29,
    transform: "translate(67.57 53.24) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.35,
    y: 25.92,
    width: 3.28,
    height: 1.39,
    rx: 0.29,
    transform: "translate(13.98 53.24) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,13.82a21.6,21.6,0,0,1,8.3.48,19.5,19.5,0,0,1,7.79,3.85,18.44,18.44,0,0,1,5.29,7.32A24.91,24.91,0,0,1,23,34.22H17.77a56.36,56.36,0,0,1,.3-5.74c.2-1.89.47-3.76.83-5.63a45.57,45.57,0,0,1,3.55-10.94,30.4,30.4,0,0,1,3.06-5,19.74,19.74,0,0,1,4.27-4.14A15.48,15.48,0,0,1,35.14.32,15.27,15.27,0,0,1,40.81.21a19.43,19.43,0,0,0-5.09,1.71,14.49,14.49,0,0,0-4,3.08,24.68,24.68,0,0,0-5,8.71A58.2,58.2,0,0,0,24.11,23.8c-.28,1.73-.52,3.47-.7,5.22s-.3,3.55-.37,5.2H17.77a23.79,23.79,0,0,0-.88-7.14,17.89,17.89,0,0,0-1.37-3.25,18,18,0,0,0-2-2.91,21,21,0,0,0-6-4.46A30.94,30.94,0,0,0,0,13.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.48,
    cy: 6.17,
    r: 5.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.31,21.19,52.44,3.71a.54.54,0,0,1,.44-.28h.26a.54.54,0,0,1,.44.28l8.13,17.48a.46.46,0,0,1-.44.67H58.39c-.47,0-.68-.15-.91-.65l-.94-2.05H49.48l-.94,2.08a1,1,0,0,1-.93.62H44.76A.46.46,0,0,1,44.31,21.19ZM55,15.63l-2-4.28h0L51,15.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.73,3.43A8.73,8.73,0,0,1,78,5.84a.49.49,0,0,1,0,.73l-2,2.1a.46.46,0,0,1-.65,0,5.32,5.32,0,0,0-3.5-1.32,5.17,5.17,0,0,0-5.09,5.35A5.14,5.14,0,0,0,71.88,18a5.46,5.46,0,0,0,3.48-1.25.53.53,0,0,1,.68,0l2,2.15a.52.52,0,0,1,0,.7,8.9,8.9,0,0,1-6.31,2.52,9.35,9.35,0,1,1,0-18.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.48,7.5H79.77A.49.49,0,0,1,79.28,7V4.18a.49.49,0,0,1,.49-.49H91.3a.49.49,0,0,1,.49.49V7a.49.49,0,0,1-.49.49H87.59V21.37a.51.51,0,0,1-.5.49H84a.51.51,0,0,1-.5-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.39,4.18a.5.5,0,0,1,.49-.49H98a.5.5,0,0,1,.49.49V21.37a.5.5,0,0,1-.49.49H94.88a.5.5,0,0,1-.49-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.62,4.36a.45.45,0,0,1,.44-.67h3.45A.5.5,0,0,1,105,4l4.29,9.48h.15L113.67,4a.53.53,0,0,1,.45-.28h3.45a.45.45,0,0,1,.44.67l-8.15,17.47a.5.5,0,0,1-.44.29h-.26a.48.48,0,0,1-.44-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.14,4.18a.48.48,0,0,1,.49-.49h10.75a.49.49,0,0,1,.49.49V7a.49.49,0,0,1-.49.49h-7.19v3.22h5.92a.51.51,0,0,1,.49.5v2.83a.49.49,0,0,1-.49.49h-5.92V18h7.19a.5.5,0,0,1,.49.5v2.83a.49.49,0,0,1-.49.49H120.63a.48.48,0,0,1-.49-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.08,27.91a.45.45,0,0,1,.47-.62h3a.53.53,0,0,1,.46.36l2.24,8.8h.1l4-9.14a.51.51,0,0,1,.45-.28h.46a.44.44,0,0,1,.44.28l4,9.14h.1l2.23-8.8a.56.56,0,0,1,.47-.36h3a.45.45,0,0,1,.47.62L61.19,45.36a.5.5,0,0,1-.47.36h-.41a.51.51,0,0,1-.44-.29L55.12,34.81H55L50.31,45.43a.51.51,0,0,1-.44.29h-.41a.5.5,0,0,1-.47-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.78,44.78l8.13-17.47a.54.54,0,0,1,.44-.28h.26a.54.54,0,0,1,.44.28l8.13,17.47a.46.46,0,0,1-.44.68H79.85c-.46,0-.67-.16-.9-.65L78,42.76H71L70,44.84a1,1,0,0,1-.93.62H66.22A.46.46,0,0,1,65.78,44.78Zm10.67-5.55-2-4.28h0l-1.94,4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3,27.78a.51.51,0,0,1,.5-.49h3.11a.51.51,0,0,1,.5.49V45a.51.51,0,0,1-.5.49H85.8a.51.51,0,0,1-.5-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.21,31.1H92.49a.49.49,0,0,1-.49-.49V27.78a.49.49,0,0,1,.49-.49H104a.49.49,0,0,1,.49.49v2.83a.49.49,0,0,1-.49.49h-3.71V45a.51.51,0,0,1-.5.49H96.7a.5.5,0,0,1-.49-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.11,27.78a.5.5,0,0,1,.49-.49h3.12a.5.5,0,0,1,.49.49V45a.5.5,0,0,1-.49.49H107.6a.5.5,0,0,1-.49-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.65,27.49a.48.48,0,0,1,.49-.46h.65l10.36,10h0V27.78a.48.48,0,0,1,.49-.49h3.11a.51.51,0,0,1,.5.49V45.25a.5.5,0,0,1-.5.47h-.41a.78.78,0,0,1-.34-.13L119.78,35.28h0V45a.49.49,0,0,1-.49.49h-3.09a.51.51,0,0,1-.5-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,27.05a10.06,10.06,0,0,1,6.34,2.44.46.46,0,0,1,.05.7l-2.05,2.18a.53.53,0,0,1-.7,0,4.78,4.78,0,0,0-3.4-1.25,5.21,5.21,0,0,0,0,10.41,6.17,6.17,0,0,0,2.31-.41V39.64H144.7a.47.47,0,0,1-.5-.46V36.61a.48.48,0,0,1,.5-.5h5.22a.49.49,0,0,1,.46.5l0,7a.63.63,0,0,1-.21.42,13.14,13.14,0,0,1-6.44,1.68,9.32,9.32,0,1,1,0-18.64Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0ddb522828374feb39e6cce2230c6317.svg";
export { ForwardRef as ReactComponent };